import React, { Component } from 'react'
import { Context } from '../Context'
import logo from '../../assets/rhomberg-logo.svg'
import BauenIcon from '../../assets/icons/build_in_the_stock.svg'
import BauserviceIcon from '../../assets/icons/construction_service.svg'
import OtImage from '../../assets/grass.png'
import IconLink from '../Libs/IconLink'
import AnimatedLogo from '../Libs/AnimatedLogo'
import AnimatedBackgroundImage from '../Libs/AnimatedBackgroundImage'
import LeistungIcon from '../../assets/icons/overview.svg'
import { Link } from 'react-router-dom'

export default class Home extends Component {
    static contextType = Context

    constructor(props) {
        super(props)

        this.state = {
            itemIndexRingAnimation: null,
        }
    }

    componentDidMount() {
        this.setRingAnimationTimer()
    }

    componentWillUnmount() {
        this.resetRingAnimationTimer()
    }

    setRingAnimationTimer() {
        this.resetRingAnimationTimer()
        this.timer = setInterval(() => {
            this.setRingAnimationItemIndex()
        }, 2000)
        this.setRingAnimationItemIndex()
    }

    resetRingAnimationTimer() {
        clearInterval(this.timer)
    }

    setRingAnimationItemIndex() {
        this.setState({
            itemIndexRingAnimation: this.state.itemIndexRingAnimation !== 0 ? 0 : 1,
        })
    }

    render() {
        return (
            <div className="main">
                <AnimatedLogo image={logo} />
                <div className="row h-100">
                    <div className="col-12 col-md-8 h-100">
                        <div className="row h-50 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around mt-5">
                                    <div className="col-12">
                                        <h1 className="text-red ml-3">
                                            Bauen liegt in
                                            <br />
                                            unserer Natur.
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row h-50 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around mb-5">
                                    <div className="col-6">
                                        <IconLink
                                            ringClass={this.state.itemIndexRingAnimation === 0 ? 'pulse' : ''}
                                            className="text-white"
                                            to="/bauen-im-bestand"
                                            image={BauenIcon}
                                            title="Bauen im Bestand"
                                        />
                                    </div>
                                    <div className="col-6">
                                        <IconLink
                                            ringClass={this.state.itemIndexRingAnimation === 1 ? 'pulse' : ''}
                                            className="text-white"
                                            to="/bauservice"
                                            image={BauserviceIcon}
                                            title="Bauservice"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5">
                                <Link to="/leistungsubersicht">
                                    <div className="services-ovewview-link" onClick={() => this.context.updateState({ sideMenu: false })}>
                                        <img src={LeistungIcon} />
                                        <br />
                                        <span className="text-white">Leistungsübersicht</span>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 d-sm-none d-md-block h-100">
                        <AnimatedBackgroundImage class="animated-background-image" imageStyle={{ marginTop: 0 }} image={OtImage} maxMoveX={400} maxMoveY={400} />
                    </div>
                </div>
            </div>
        )
    }
}
